import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import BlogCard from 'src/components/NodeBlogCard/NodeBlogCard';
import { PortableHeader } from 'src/components/PortableHeader/PortableHeader';

export const BlogPostListing = ({ type, header, posts, isDark }) => {
  const data = useStaticQuery(graphql`
    {
      allSanityBlogPost(sort: { publicationDate: DESC }) {
        nodes {
          ...getBlogPostAsCard
        }
      }
    }
  `);

  const types = {
    showAllPosts: data.allSanityBlogPost.nodes,
    showLatestPosts: data.allSanityBlogPost.nodes.slice(0, 2),
    selectSpecificPosts: posts,
  };

  const postsToShow = types[type];

  return (
    <Container fluid className={`${isDark ? 'bg-darker' : ''} px-0`}>
      <Container>
        {header && (
          <Row className="pt-6">
            <PortableHeader className={`${isDark ? 'text-white' : ''} py-5`} content={header} />
          </Row>
        )}
        <Row>
          {postsToShow.map((post, i) => {
            if (i === 0 || i === 1)
              return (
                <Col key={post.id} xs={12} lg={6} className="py-5">
                  <BlogCard post={post} darkMode={isDark} />
                </Col>
              );
            return (
              <Col key={post.id} xs={12} lg={6} xl={4} className="py-4">
                <BlogCard post={post} darkMode={isDark} />
              </Col>
            );
          })}
        </Row>
      </Container>
    </Container>
  );
};
